export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11895.22075cf1.jpg";